import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IAccordionMetadata {
  id?: string;
  meta_title?: string;
  meta_title_text_color?: string;
  meta_description?: string;
  meta_priority?: number;
  meta_status?: boolean;
}

export interface IAccordion {
  id?: number;
  page_id?: number;
  component_id?: number;
  background_color?: string;
  variant?: string;
  status?: boolean;
  metadata?: IAccordionMetadata[];
}

/**
 * Create accordion entry
 */
export async function createAccordion(payload: Partial<IAccordion>) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.ACCORDION.CREATE, payload);
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Update accordion
 */
export async function updateAccordion(id: number, payload: Partial<IAccordion>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.ACCORDION.UPDATE(id), payload);
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get accordion by page ID
 */
export async function getAccordionByPageId(pageId: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.ACCORDION.GET_BY_PAGE_ID(pageId));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 404) {
      return null;
    }
    const errorResponse = handleApiError(axiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Delete accordion
 */
export async function deleteAccordion(id: number) {
  try {
    const response = await adminAxios.delete(ADMIN_API_ENDPOINTS.ACCORDION.DELETE(id));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
